export function Logo(props) {
  return (
    <img
      src="GamberaDynamicsLogo.svg"
      className="w-20 lg:w-36"
      alt="gd-rms_logo"
    />
  );
}
